import { Provider } from "react-redux";
import { Container, Typography } from "@mui/material";
import Header from "../components/Header/Header";
import CreateNewTeachingAccountSteps from "../components/MainWebsiteComponent/CreateNewTeachingAccountSteps/CreateNewTeachingAccountSteps"
import Footer from "../components/MainWebsiteComponent/Footer/Footer";

import store from "../components/MainWebsiteComponent/store"

const CreateNewTeachingAccount = (props) => {

  const {subdomain, updateCart, setUpdateCart, openSignUpModel, setOpenSignUpModel} = props;

  return (
    <>
      <Header subdomain={subdomain} updateCart={updateCart} setUpdateCart={setUpdateCart} openSignUpModel={openSignUpModel} setOpenSignUpModel={setOpenSignUpModel} />
     
      <div style={{paddingTop:"32px", background:"#f5f5f5", position:"fixed",height:"100%", width:"100%",}}></div>
     <div style={{paddingTop:"32px", position:"relative",}}>
    
      <Container>
        <Typography
          variant="h2"
          sx={{ mb: 3, fontSize: "34px", fontWeight: "bold" }}
        >
          Create New Teaching Account
        </Typography>
        <Provider store={store}>
            <CreateNewTeachingAccountSteps/>
        </Provider>
      </Container>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default CreateNewTeachingAccount;
